import 'waypoints/lib/noframework.waypoints';

class ProductHeader {
	constructor(container) {
		if (!container || typeof window.Waypoint !== 'function') return;

		this.container = container;
		this.setupInView();

		this.navigation = container.querySelector('#productHeaderNavigationList');
		if (!this.navigation) return;

		this.sections = this.getPageScrollSections();

		this.setupPageScroll();
		this.bindNavigationLinks();

		// Refresh for third party content
		this.initObserver();
	}

	setupInView() {
		this.trigger = getInViewTrigger();
		if (!this.trigger) return;

		const activeClass = 'product-header--is-active';

		new window.Waypoint({
			element: this.trigger,
			offset: this.trigger.offsetHeight * -1,
			handler: direction => {
				if (direction === 'down') {
					this.container.classList.add(activeClass);
				} else {
					this.container.classList.remove(activeClass);
				}
			},
		});
	}

	setupPageScroll() {
		this.sections.forEach(el => this.attachScrollPoint(el));
	}

	bindNavigationLinks() {
		this.navigation.addEventListener('click', e => this.scrollToSection(e));
	}

	attachScrollPoint(element) {
		if (!element) return;
		const self = this;

		new window.Waypoint({
			element,
			offset: this.container.offsetHeight,
			group: 'pageScroll',
			handler(direction) {
				const previous = this.previous() && this.previous().element;
				const activeSection = direction === 'up' ? previous : this.element;

				if (activeSection) {
					self.toggleActiveScrollLink.call(self, activeSection.id);
				}
			},
		});
	}

	toggleActiveScrollLink(active) {
		const activeClass = 'product-header__navigation-list-item--is-active';

		this.removeActiveScrollLinks(activeClass);
		this.setActiveScrollLink(active, activeClass);
	}

	removeActiveScrollLinks(activeClass) {
		Array.from(this.navigation.querySelectorAll('li')).forEach(li =>
			li.classList.remove(activeClass),
		);
	}

	setActiveScrollLink(active, activeClass) {
		const activeListItem = this.navigation.querySelector(
			`li[data-section="${active}"]`,
		);

		if (activeListItem) {
			activeListItem.classList.add(activeClass);
		}
	}

	scrollToSection(event) {
		if (event.target.tagName === 'A' && event.target.hash) {
			event.preventDefault();

			const targetId = event.target.hash.substring(1);
			const targetSection = this.sections.find(
				section => section.id === targetId,
			);

			if (targetSection) {
				const scrollY = targetSection.offsetTop - this.container.offsetHeight;

				window.scrollTo({
					top: scrollY,
					behavior: 'smooth',
				});

				const sku = this.container.getAttribute('data-product-sku');

				window.od.events.publish('productHeader_Click', {
					url: window.location.href,
					key: targetId.substring(7),
					sku,
				});
			}
		}
	}

	getPageScrollSections() {
		const navLinks = this.navigation.querySelectorAll('li');

		return Array.from(navLinks).map(link => {
			const sectionId = link.getAttribute('data-section');
			return document.getElementById(sectionId);
		});
	}

	initObserver() {
		if ('MutationObserver' in window) {
			const targetNode = document.getElementById('productDetails');
			const config = { attributes: true, childList: true, subtree: true };

			const observer = new MutationObserver(window.Waypoint.refreshAll);
			observer.observe(targetNode, config);
		}
	}
}

function getInViewTrigger() {
	return document.querySelector('[id^="addToCartForm_"]');
}

export default ProductHeader;
